module.exports = ".submit-btn-wrapper{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/upload-layout/upload-layout.component.css
// module id = ./src/app/upload-layout/upload-layout.component.css
// module chunks = main